import React, { createContext, useContext } from 'react';

export type ClaimShopSettings = {
  isClaimMeCustomer: boolean;
  isEasyDOREnabled: boolean;
  isInvoiceExtractionEnabled: boolean;
  isInvoiceImportEnabled: boolean;
  isDORSigningLinkEnabled: boolean;
  isOrderItemLevelTaxEnabled: boolean;
  isPercentageDiscountEnabled: boolean;
  isPhotoCollectionAppEnabled: boolean;
  isDefaultTaxIncluded: boolean;
  isSpecialInvestigationFlowEnabled: boolean;
};

const defaultValue: ClaimShopSettings = {
  isClaimMeCustomer: false,
  isEasyDOREnabled: false,
  isInvoiceExtractionEnabled: false,
  isInvoiceImportEnabled: false,
  isDORSigningLinkEnabled: false,
  isOrderItemLevelTaxEnabled: false,
  isPercentageDiscountEnabled: false,
  isPhotoCollectionAppEnabled: false,
  isDefaultTaxIncluded: true,
  isSpecialInvestigationFlowEnabled: false,
};

const ClaimsShopSettingsContext = createContext<ClaimShopSettings>(defaultValue);

type Props = {
  value?: Partial<ClaimShopSettings>;
  children: React.ReactNode;
};

export function ClaimsShopSettingsContextProvider({ value, children }: Props) {
  return (
    <ClaimsShopSettingsContext.Provider value={{ ...defaultValue, ...value }}>
      {children}
    </ClaimsShopSettingsContext.Provider>
  );
}

export function useClaimsShopSettings(): ClaimShopSettings {
  return useContext(ClaimsShopSettingsContext);
}
